import { createStore, applyMiddleware } from 'redux';
import ArtistEventLocalShowReducer from '../reducers/ArtistEventLocalShowReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(ArtistEventLocalShowReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
